import { css } from '@emotion/react';
import { spacing } from '@prototyp/gatsby-plugin-gumball/mixins';
import { breakpoints } from 'style/variables';

export const search = css`
  min-width: ${spacing(580)};
`;

export const sectionHead = css`
  & > div:last-of-type {
    flex: 1;
    margin-left: ${spacing(64)};

    @media ${breakpoints.xxLarge} {
      flex: 0.6;
      margin-left: 0;
    }
  }
`;

export const searchFilter = css`
  display: flex;
  align-items: center;
  justify-content: space-between;

  & > * + * {
    margin-left: ${spacing(12)};
  }
`;

export const sortByDropdown = css`
  font-weight: var(--font-weight-regular);
  padding: 0;
  text-align: start;
`;

export const datePickers = css`
  display: flex;

  & > div {
    margin-right: ${spacing(32)};
  }
`;
